module.exports = __webpack_public_path__ + "static/media/io.8daa0f5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/io.svg
// module id = 151
// module chunks = 0